import { uniq } from 'lodash'

export type FilterGroup = {
  Groups?: any[],
  Rules?: any[],
}

export type Filter = {
  OrgId?: string,
  OrgType?: number,
  Parameter1?: string | number,
  Parameter2?: string | number,
  Parameter3?: string | number,
  Parameter4?: string | number,
  Parameter5?: string | number,
  Parameter6?: string | number,
  Keyword?: string | number,
  Sort?: string | number,
  Order?: number,
  PageIndex?: number,
  Limit?: number,
  Start?: number,
  AuthOrgCodes?: any,
  Include?: Array<any>,
  IgnoreOrgRule?: boolean,
  Orders?: { Field: string, Order: number }[],
  SelectField?: Array<any>
}

export function initFilter (init: Filter) {
  const {
    OrgId,
    OrgType,
    Parameter1,
    Parameter2,
    Parameter3,
    Parameter4,
    Parameter5,
    Parameter6,
    Keyword = "",
    Sort,
    Order = 0,
    PageIndex = 1,
    Limit = 10,
    Start = ((init.PageIndex || 1) - 1) * (init.Limit || 10),
    AuthOrgCodes,
    Include = [],
    IgnoreOrgRule,
    Orders = [],
    SelectField = []
  } = init
  return {
    OrgId,
    OrgType,
    Parameter1,
    Parameter2,
    Parameter3,
    Parameter4,
    Parameter5,
    Parameter6,
    Keyword,
    Sort,
    Order,
    PageIndex,
    Limit,
    Start,
    RuleCount: 0,
    IncludeCount: 0,
    OrderCount: 0,
    FilterGroupCount: 0,
    AuthOrgCodes,
    Include,
    IgnoreOrgRule,
    Orders,
    FilterGroup: { Rules: [], Groups: [] },
    SelectField,
    DataRule: []
  }
}

/**
 * 获取单个 rule
 * @param Field 字段
 * @param Operate 操作符
 * @param Value 值
 * @param IsSysParamRule 系统规则
 * @returns 
 */
export function getSingleRule (
  Field: string,
  Operate: number,
  Value: number | string,
  IsCustom?: boolean,
  IsSysParamRule?: boolean
) {
  Value = Value === null ? '' : Value
  return {
    Field,
    Operate,
    Value: IsSysParamRule ? Value.toString() : Value,
    /**
     * 不要用 !! 强制转换，保留可以为 undefined 的场景，
     * 因为 IsCustom 并非后端所需参数，只是前端标记，用作将参数添加进请求参数的根对象上而已
     */
    IsCustom,
    IsSysParamRule: !!IsSysParamRule
  }
}

/**
 * 扩展 FilterGroup.Rules 数组
 * @param target 
 * @param rules 
 */
export function extendRules (target: any, rules: any[]) {
  // 自定义过滤规则，过滤规则: pf001 -> 列表配置 -> 操作：过滤
  const customRules = rules.filter(item => item.IsCustom)
  customRules.forEach(({ Field, Value }) => {
    if (Field.indexOf(',') !== -1) {
      const splitFileds = Field.split(',')
      const splitValues = Value.toString().split(',')
      splitFileds.forEach((n: any, i: number) => {
        target[n] = splitValues[i]
      })
    } else {
      target[Field] = Value
    }
  })

  if (Array.isArray(target.FilterGroup?.Rules)) {
    const commonRules = rules.filter(item => !item.IsCustom)
    target.FilterGroup.Rules = ([] as any).concat(target.FilterGroup.Rules, commonRules)
  }
}

/**
 * 扩展 filter.Include 数组
 * @param target 
 * @param includes 
 */
export function extendInclude (target: any, includes: string[]) {
  if (Array.isArray(target?.Include)) {
    target.Include = uniq(([] as string[]).concat(target.Include, includes))
  }
}

/**
 * FilterGroup.Groups 对象
 * @param IsAnd 与条件
 * @returns 
 */
export function initGroup (IsAnd: boolean = true) {
  return {
    IsAnd,
    Rules: [],
    Groups: [],
  }
}

/**
 * 扩展 FilterGroup.Groups 数组
 * @param target 
 * @param groups 
 */
export function extendGroups (target: any, groups: any[]) {
  if (Array.isArray(target.FilterGroup?.Groups)) {
    target.FilterGroup.Groups = ([] as any).concat(target.FilterGroup.Groups, groups)
  }
}

/**
 * 扩展 Orders 数组
 * @param target 
 * @param orders 
 */
export function extendOrders (target: any, orders: any[]) {
  if (Array.isArray(target.Orders)) {
    target.Orders = ([] as any).concat(target.Orders, orders)
  }
}

type Target = {
  FilterGroup: FilterGroup,
  OrgType?: number | string,
  MenuParameter?: number | string,
  [propName: string]: any
}

type Source = {
  Rules?: Array<any>,
  Groups?: Array<any>,
  OrgType?: number | string,
  MenuParameter?: number | string
}

/**
 * target 添加 OrgType 或 MenuParameter，target.FilterGroup 添加 Rules 和 Groups
 * @param {Object} target 目标对象
 * @param {Object} target.FilterGroup
 * @param {Object} target.OrgType
 * @param {Object} target.MenuParameter
 * @param {Object} source
 * @param {Object} source.Rules
 * @param {Object} source.Groups
 * @param {Object} source.OrgType
 * @param {Object} source.MenuParameter
 */
export function extendRulesAndGroups (target: Target, source: Source = {}) {
  const { Rules, Groups, OrgType, MenuParameter } = source
  OrgType && (target.OrgType = OrgType)
  MenuParameter && (target.MenuParameter = MenuParameter)

  if (Array.isArray(Rules) && Rules.length) {
    extendRules(target, Rules)
  }

  if (Array.isArray(Groups) && Groups.length) {
    extendGroups(target, Groups)
  }
}